var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 21c5.02 0 9.09-3.95 9.09-8.823 0-2.19-.82-4.193-2.181-5.736m-.545 3.088V6H22M12 3c-5.02 0-9.09 3.95-9.09 8.824 0 2.19.82 4.192 2.181 5.735m.545-3.088V18H2"
}))));
export default SvgResetIcon;